import {IconName} from '@lightricks/react-design-system';
import type {CreatorStatus} from './creatorTabTypes';

const ALL_STATUSES = 'all';

export type CreatorActionVisibility = CreatorStatus | typeof ALL_STATUSES;

export type CreatorActionConfigItem = {
  id: string;
  label: string;
  icon: IconName;
  visibleOnStatuses: CreatorActionVisibility[];
};

export const CREATOR_ACTION_CONFIG: CreatorActionConfigItem[] = [
  {
    id: 'accept',
    label: 'Accept',
    icon: 'Actions-Patch-Accept-Line',
    visibleOnStatuses: ['applications'],
  },
  {
    id: 'reject',
    label: 'Reject',
    icon: 'Actions-Patch-Cancel-Line',
    visibleOnStatuses: ['applications'],
  },
  {
    id: 'negotiate',
    label: 'Negotiate',
    icon: 'Actions-Remix',
    visibleOnStatuses: ['applications'],
  },
  {
    id: 'withdraw',
    label: 'Withdraw Offer',
    icon: 'Actions-Remix',
    visibleOnStatuses: ['applications'],
  },
  {
    id: 'vet',
    label: 'Vet',
    icon: 'Navigation-Shopbag-Shield-Stroke',
    visibleOnStatuses: ['applications', 'hired'],
  },
  {
    id: 'message',
    label: 'Message',
    icon: 'Navigation-Messages',
    visibleOnStatuses: ['hired'],
  },
  {
    id: 'change-due-date',
    label: 'Change due date',
    icon: 'Navigation-Calendar',
    visibleOnStatuses: ['hired'],
  },
  {
    id: 'move-to-complete',
    label: 'Move to complete',
    icon: 'Actions-Patch-Accept-Line',
    visibleOnStatuses: ['hired'],
  },
  {
    id: 'remove',
    label: 'Remove',
    icon: 'Actions-Remove',
    visibleOnStatuses: ['hired'],
  },
  {
    id: 'add-to-shortlist',
    label: 'Add to shortlist',
    icon: 'Navigation-Heart-Line',
    visibleOnStatuses: ['applications'],
  },
  {
    id: 'add-to-list',
    label: 'Add to List',
    icon: 'Actions-Bookmark',
    visibleOnStatuses: [ALL_STATUSES],
  },
  {
    id: 'share',
    label: 'Share',
    icon: 'Actions-Share',
    visibleOnStatuses: [ALL_STATUSES],
  },
];

const ACTION_CONFIG_MAP = new Map(CREATOR_ACTION_CONFIG.map((a) => [a.id, a]));

export function getActionConfig(
  id: string
): CreatorActionConfigItem | undefined {
  return ACTION_CONFIG_MAP.get(id);
}

export function isActionVisibleForStatus(
  action: CreatorActionConfigItem,
  status: CreatorStatus
): boolean {
  return (
    action.visibleOnStatuses.includes(ALL_STATUSES) ||
    action.visibleOnStatuses.includes(status)
  );
}
